import { css } from 'emotion';

const retryStyles = css`
	.retry {
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
	}

	.retry__message {
		align-self: center;
		margin-bottom: 24px;
	}

	.retry__buttonContainer {
		align-self: center;
		margin-bottom: 24px;
	}
`;

export { retryStyles };
